import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as groupedProductsFromSomeoneElseState from '../employee-detail.reducer';
import * as groupedProductsFromSomeoneElseReducer from '../reducers/grouped-products-from-someone-else.reducer';

export const getGroupedProductsFromSomeoneElse = createSelector(
  groupedProductsFromSomeoneElseState.getGroupedProductsFromSomeoneElseState,
  groupedProductsFromSomeoneElseReducer.getGroupedProductsFromSomeoneElseResponse
);
